import React, {useEffect, useState} from 'react';
import {getUserFriendlyErrorMessage} from '@/utils/errorHandling.ts';
import {
  Button,
  EmptyState,
  ErrorHappened,
  HeadingSize,
  Label,
  LabelType,
  Loading,
  NoResultsFound,
  Search,
  SorterResult,
  Table,
  useKeyboardShortcut
} from '@fs/uikit-react';
import styles from './ContactLinkCategoriesPage.module.css';
import {ApiError} from '@/services/api';
import {
  refreshContactLinkCategories,
  useInit,
} from "@/pages/Operator/ContactLinkCategory/hooks/useInit.ts";
import {
  filteredItems,
  getRowActions,
  getTableColumns,
  handleCreateItem,
  handleDeleteItem,
  handleEditItem
} from "./table.tsx";
import { ContactLinkCategory } from '@/shared/model/contactLinkCategory.ts';

const ContactLinkCategoriesPage: React.FC = () => {
  const [searchValue, setSearchValue] = useState('');

  const [items, setItems] = useState<ContactLinkCategory[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<ApiError | null>(null);
  const [sorters, setSorters] = useState<SorterResult[]>([]);

  useInit(setItems, setLoading, setError);

  useEffect(() => {
    refreshContactLinkCategories();
  }, []);

  useKeyboardShortcut('c', [], handleCreateItem);

  const filtered = filteredItems(items, searchValue);

  const renderHeader = () => {
    return (
      <div className={styles.title}>
        <Label
          text={'Категорії посилань'}
          type={LabelType.HEADING}
          headingSize={HeadingSize.L}
        />
        <div className={styles.buttonContainer}>
          <Button
            onClick={handleCreateItem}
            title="Створити категорію"
          />
        </div>
      </div>
    );
  };

  const renderSearch = () => {
    return (
      <div className={styles.searchButtonContainer}>
        <div className={styles.searchContainer}>
          <Search
            placeholder="Пошук категорій посилань"
            value={searchValue}
            onChange={setSearchValue}
          />
        </div>
      </div>
    );
  };

  const renderContent = () => {
    if (loading) {
      return <Loading text="Завантажуємо категорії посилань..." className={styles.loadingState} />;
    }

    if (error) {
      return <ErrorHappened text={getUserFriendlyErrorMessage(error as ApiError)} />;
    }

    if (filtered.length === 0) {
      if (searchValue) {
        return (
          <NoResultsFound
            text={`Немає результатів за запитом "${searchValue}"`}
          />
        );
      } else {
        return <EmptyState text="Немає доступних категорій посилань" />;
      }
    }

    return (
      <Table
        data={filtered || []}
        columns={getTableColumns()}
        rowActions={getRowActions(handleDeleteItem)}
        onClick={(record) => {
          handleEditItem(record as ContactLinkCategory);
        }}
        onSort={setSorters}
        initialSorters={sorters}
      />
    );
  };

  return (
    <div className={styles.container}>
      {renderHeader()}
      <div>
        {renderSearch()}
        {renderContent()}
      </div>
    </div>
  );
};

export default ContactLinkCategoriesPage;
